import React from 'react'

const IconOne: React.FC = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clipRule="evenodd"
        d="M10.002 0C4.47939 0 0.00195312 4.47677 0.00195312 10C0.00195312 15.5226 4.47872 20 10.002 20C15.5245 20 20.002 15.5226 20.002 10C20.002 4.47677 15.5252 0 10.002 0ZM12.3262 7.29803V7.62012H12.3255V11.9458C12.3255 12.977 11.9192 13.9579 11.1902 14.6875C10.4612 15.4165 9.47972 15.8228 8.44917 15.8228C7.41795 15.8228 6.43711 15.4165 5.7081 14.6875C4.97909 13.9585 4.57283 12.977 4.57283 11.9458C4.57283 10.9146 4.97909 9.93373 5.7081 9.20472C6.43711 8.47571 7.41795 8.06945 8.44917 8.06945H9.16757V10.1074H8.44784C7.95808 10.1074 7.49351 10.2996 7.14756 10.6462C6.80161 10.9921 6.60942 11.4567 6.60942 11.9465C6.60942 12.4362 6.80161 12.9008 7.14756 13.2467C7.49351 13.5927 7.95808 13.7855 8.44784 13.7855C8.9376 13.7855 9.40218 13.5927 9.74813 13.2467C10.0941 12.9008 10.2863 12.4362 10.2863 11.9504V4.17655H12.3156L12.417 4.36477C12.7331 4.95063 13.1592 5.50534 13.6874 5.91557C14.0963 6.23235 14.5589 6.4557 15.0699 6.54583L15.4311 6.60945L15.0434 8.57446L14.6961 8.51216C14.2826 8.43794 13.877 8.31268 13.4966 8.13374C13.0618 7.92697 12.6575 7.64928 12.3262 7.29803Z"
        fill="white"
      />
    </svg>
  )
}

export default IconOne
